import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../config";

export const getPortfolios = createAsyncThunk("portfolio/getAll", async () => {
  const response = await fetch(`${config.apiBaseUrl}/user-portfolio-show`, {
    method: "GET",
  });

  const result = await response.json();
  return result;
});

export const getPortfolioById = createAsyncThunk(
  "portfolio/getOne",
  async (id) => {
    const response = await fetch(
      `${config.apiBaseUrl}/user-click-portfolio/${id}`,
      {
        method: "GET",
      },
    );

    const result = await response.json();
    return result;
  },
);

export const getAllProjectImages = createAsyncThunk(
  "portfolio/getAllProjectImages",
  async (projectIds, { dispatch }) => {
    const allImages = [];

    for (let id of projectIds) {
      // Mövcud thunk istifadə olunur
      const projectData = await dispatch(getPortfolioById(id)).unwrap();
      allImages.push({
        id: projectData._id,
        title: projectData.title,
        images: projectData.media || [],
      });
    }


    console.log(allImages);
    return allImages;
  },
);

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState: {
    portfolios: [],
    selectedPortfolio: null,
    allProjectImages: [],
    status: "idle",
    detailStatus: "idle",
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getPortfolios.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPortfolios.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.portfolios = action.payload;
      })
      .addCase(getPortfolios.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(getPortfolioById.pending, (state) => {
        state.detailStatus = "loading";
      })
      .addCase(getPortfolioById.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.selectedPortfolio = action.payload;
      })
      .addCase(getPortfolioById.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.error = action.error.message;
      })

       .addCase(getAllProjectImages.pending, (state) => {
        state.detailStatus = "loading";
      })
      .addCase(getAllProjectImages.fulfilled, (state, action) => {
        state.detailStatus = "succeeded";
        state.allProjectImages = action.payload;
      })
      .addCase(getAllProjectImages.rejected, (state, action) => {
        state.detailStatus = "failed";
        state.error = action.error.message;
      });
  },
});

export default portfolioSlice.reducer;
